/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Kits_TitleInputs */

const en_fw_kits_title = /** @type {(inputs: Fw_Kits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from a kit`)
};

const id_fw_kits_title = /** @type {(inputs: Fw_Kits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari kit`)
};

/**
* | output |
* | --- |
* | "Start from a kit" |
*
* @param {Fw_Kits_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_kits_title = /** @type {((inputs?: Fw_Kits_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Kits_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_kits_title(inputs)
	return en_fw_kits_title(inputs)
});